import { CommonModule } from '@angular/common';
import { Component, computed, inject, Signal } from '@angular/core';
import { AuthService } from '@webapp/auth/services/auth.service';
import { SortDirection } from '@webapp/core/stores/types';
import { IconComponent, Status, UserBadgeComponent } from '@webapp/ui';
import { buildStatus } from '@webapp/users/common/map';
import {
	isUserType,
	IUserRow,
	USER_TYPES,
} from '@webapp/users/interfaces/users.interface';
import { UsersStoreService } from '@webapp/users/store/users-store.service';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-prospects-table',
	imports: [CommonModule, UserBadgeComponent, IconComponent, RouterLink],
	templateUrl: './prospects-table.component.html',
	styleUrl: './prospects-table.component.scss',
})
export class ProspectsTableComponent {
	readonly USER_TYPES = USER_TYPES;
	readonly isUserType = isUserType;
	usersStore = inject(UsersStoreService);
	sortDirection: SortDirection = 'desc';
	authService = inject(AuthService);

	canShowProducer = this.authService.isUserNotAgent();

	Status = Status;

	get rows(): Signal<IUserRow[]> {
		return computed(() => {
			const sortMultiplier = this.sortDirection === 'asc' ? 1 : -1;
			return this.usersStore
				.getRows()()
				.map(user => ({ ...user, ...buildStatus(user) }))
				.sort(
					(a, b) =>
						(a.internalNumber - b.internalNumber) * sortMultiplier
				);
		});
	}

	toggleSort() {
		this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
	}

}
